import axios from 'axios';
import resolve  from './resolver.js';

export default async function Login(username, password) {
    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/user/login', {
            method: 'post',
            header: { 'Content-Type' : 'application/json'},
            data: { 
                "username": username,
                "password": password                
            }
        })
        .then(res => res.data));        
        
}